import { EnvironmentTypes, SiteConfig, footerApp, headerApp, shellApp } from '@openedx/frontend-base';
import customApp from './src/customApp';
import { addApp, addExternalRoute } from './src/utils';


import { authnApp } from '@openedx/frontend-app-authn';



import { learnerDashboardApp } from '@openedx/frontend-app-learner-dashboard';



import { instructorDashboardApp } from '@openedx/frontend-app-instructor-dashboard';



import { notificationsApp } from '@openedx/frontend-app-notifications';



import {
  createLegacyPluginApp,
  defaultRouteMap,
  defaultSlotMap,
  defaultWidgetMap,
} from '@openedx/frontend-base-compat';
import allEnvConfig from './src/env.config.all.jsx';

const routeMap = { ...defaultRouteMap, ...{} };
const slotMap = { ...defaultSlotMap, ...{"org.openedx.frontend.layout.header_desktop_secondary_menu.v2": {"sourceAliases": ["org.openedx.frontend.layout.header_desktop_secondary_menu.v1", "desktop_secondary_menu_slot"], "targetSlotId": "de.abstracttechnology.frontend.slot.header.desktopSecondaryMenu.v1"}, "org.openedx.frontend.layout.header_desktop_user_menu.v1": {"sourceAliases": ["desktop_user_menu_slot"], "targetSlotId": "de.abstracttechnology.frontend.slot.header.desktopUserMenu.v1"}, "org.openedx.frontend.layout.header_mobile_main_menu.v1": {"sourceAliases": ["mobile_main_menu_slot"], "targetSlotId": "de.abstracttechnology.frontend.slot.header.mobileMainMenu.v1"}, "org.openedx.frontend.layout.header_mobile_user_menu.v1": {"sourceAliases": ["mobile_user_menu_slot"], "targetSlotId": "de.abstracttechnology.frontend.slot.header.mobileUserMenu.v1"}} };
const widgetMap = { ...defaultWidgetMap, ...{} };


import { aiStudioApp } from '@openedx/frontend-ai-studio-application';
import { aspectsApp } from '@openedx/frontend-app-aspects';


import '@openedx/frontend-base/shell/style';
import '@edx/brand/core.min.css';
import '@edx/brand/light.min.css';

const siteConfig: SiteConfig = {
  siteId: 'tutor-site',
  siteName: "Abstract-Technology",
  baseUrl: 'https://apps.demo.abstract-technology.de',
  cmsBaseUrl: 'https://studio.demo.abstract-technology.de',
  lmsBaseUrl: 'https://demo.abstract-technology.de',
  loginUrl: 'https://demo.abstract-technology.de/login',
  logoutUrl: 'https://demo.abstract-technology.de/logout',

  environment: EnvironmentTypes.PRODUCTION,
  apps: [
    shellApp,
    headerApp,
    footerApp,
    customApp,
  ],
  externalRoutes: [],

  runtimeConfigJsonUrl: '/api/frontend_site_config/v1/',
  accessTokenCookieName: 'edx-jwt-cookie-header-payload',
};


addApp(siteConfig, authnApp);



addApp(siteConfig, learnerDashboardApp);



addApp(siteConfig, instructorDashboardApp);



addApp(siteConfig, notificationsApp);

addApp(siteConfig, createLegacyPluginApp({
  appId: 'io.edly.frontend.app.compat.all',
  envConfig: allEnvConfig,
  routeMap,
  slotMap,
  widgetMap,
}));

addApp(siteConfig, aiStudioApp);
addApp(siteConfig, aspectsApp);


export default siteConfig;